module.exports = __webpack_public_path__ + "images/emoji/open_hands.07eb89367a734774a0c3.png";